import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';
import { getBrandingForEmployee } from '../config/brandingStore';
import { formatDate } from '../utils/dateUtils';

Font.register({
  family: 'Amiri',
  src: require("../assets/Amiri.ttf")
});

const EntryAuthorizationPDF = ({
  data
}) => {
  // Obtenir le branding selon le site de l'employé
  const BRAND = getBrandingForEmployee(data.employee);
  
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.container}>
          <View style={styles.logo}>
            <Image src={BRAND.pdfLogo} style={styles.logoImage} />
          </View>

          <Text style={styles.headerDate}>{BRAND.pdfHeader.city} {BRAND.pdfHeader.dateLabel} {formatDate(data.createdAt)}</Text>

          <Text style={styles.mainTitleArabic}>
            رخصة دخول
          </Text>
          <br></br>
          <Text style={styles.mainTitle}>
            AUTORISATION D'ENTRÉE Personnel / Professionnel
          </Text>

          <View style={styles.formGroup}>
            <Text style={styles.fieldArticle}>
              Suivant article N°33 du règlement intérieur, nous autorisons l'employé(e) cité(e) ci-dessous à reprendre son poste.
            </Text>

            {/* NOM */}
            <View style={styles.fieldRow}>
              <Text style={styles.field}>
                NOM : <Text style={styles.fieldValue}>{data.employee?.last_name || '............................'}</Text>
              </Text>
              <Text style={styles.arabicLabel}>اللقب</Text>
            </View>

            {/* PRENOM */}
            <View style={styles.fieldRow}>
              <Text style={styles.field}>
                PRENOM : <Text style={styles.fieldValue}>{data.employee?.first_name || '............................'}</Text>
              </Text>
              <Text style={styles.arabicLabel}>الاسم</Text>
            </View>

            {/* FONCTION */}
            <View style={styles.fieldRow}>
              <Text style={styles.field}>
                FONCTION : <Text style={styles.fieldValue}>{data.employee?.poste || '............................'}</Text>
              </Text>
              <Text style={styles.arabicLabel}>الخدمة</Text>
            </View>

            {/* MOTIF */}
            <View style={styles.fieldRow}>
              <View style={styles.fieldContainer}>
                <Text style={styles.field}>
                  MOTIF : <Text style={styles.fieldValue}>{data.reason || '............................'}</Text>
                </Text>
              </View>
              <Text style={styles.arabicLabel}>السبب</Text>
            </View>

            {/* DATE D'ENTREE */}
            <View style={styles.fieldRow}>
              <Text style={styles.field}>
                DATE D'ENTRÉE : <Text style={styles.fieldValue}>{formatDate(data.entree_date) || '............................'}</Text>
              </Text>
              <Text style={styles.arabicLabel}>تاريخ الدخول</Text>
            </View>

            {/* HEURE D'ENTREE */}
            <View style={styles.fieldRow}>
              <Text style={styles.field}>
                HEURE D'ENTRÉE : <Text style={styles.fieldValue}>{data.entree_time || '............................'}</Text>
              </Text>
              <Text style={styles.arabicLabel}>توقيت الدخول</Text>
            </View>
          </View>

          <Text style={styles.fieldNote}>
            N.B : <Text style={styles.fieldValueFooter}>la présente doit être remis à la direction.             </Text>
            <Text style={styles.fieldArabic}>ملاحظة: يجب ارجاع رخصة الدخول الى الإدارة</Text>
          </Text>

          <View style={styles.spacer} />

          <View style={styles.footer}>
            <View style={styles.spacer} />
            <Text style={styles.signature}>le Directeur                                                                  L'employé(e)</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: 'Helvetica',
    fontSize: 11,
    lineHeight: 1.5,
    display: 'flex', // Ensure flex layout
    flexDirection: 'column', // Arrange children vertically
  },
  container: {
    flexGrow: 1, // Allow the container to grow and fill available space
    display: 'flex',
    flexDirection: 'column',
  },
  logo: {
    width: '100%',
    marginBottom: 10,
  },
  logoImage: {
    width: '100%',
  },
  headerDate: {
    fontSize: 11,
    textAlign: 'right',
    marginBottom: 18,
  },
  arabicTitle: {
    fontFamily: 'Helvetica',
    fontSize: 16,
    textAlign: 'right',
    textDecoration: 'underline',
    marginBottom: 10,
  },
  mainTitleArabic: {
    fontFamily: 'Amiri',
    fontSize: 22,
    textAlign: 'center',
    textDecoration: 'underline',
    fontWeight: 'bold',
    marginBottom: 13,
  },
  mainTitle: {
    marginTop: 10,
    fontSize: 16,
    textAlign: 'center',
    textDecoration: 'underline',
    fontWeight: 'bold',
    marginBottom: 20,
  },
  formGroup: {
    paddingLeft: 30,
    marginBottom: 10,
  },
  fieldArabic: {
    fontSize: 14,
    fontFamily: 'Amiri',
    textAlign: 'right',
  },
  fieldValue: {
    fontSize: 15,
    fontFamily: 'Amiri',
    fontWeight: 'normal',
  },
  fieldValueFooter: {
    fontFamily: 'Amiri',
    fontWeight: 'normal',
  },
  fieldValueArabic: {
    fontFamily: 'Amiri',
    fontWeight: 'normal',
  },
  spacer: {
    flexGrow: 1, // Pushes the footer to the bottom
  },
  footer: {
    marginTop: 20,
    paddingLeft: 30,
  },
  signature: {
    fontSize: 13,
    fontWeight: 'bold',
    marginBottom: 80,
  },
  note: {
    fontSize: 12,
  },
  fieldContainer: {
    flex: 1, // Allow the container to grow and take available space
    marginRight: 10, // Add some spacing between the field and the Arabic label
  },
  arabicLabel: {
    fontFamily: 'Amiri',
    fontSize: 15,
    marginTop: 0, // Align the label with the top of the field
    alignSelf: 'flex-start', // Align the label to the top of the row
  },
  fieldRow: {
    flexDirection: 'row',
    alignItems: 'flex-start', // Align items to the top of the row
    justifyContent: 'space-between', // Ensure space between the field and the label
    marginBottom: 9,
  },
  // Update existing field style to remove marginBottom
  field: {
    fontWeight: 'bold',
    fontSize: 12,
  },
  fieldNote: {
    fontSize: 12,
    marginBottom: 20,
    paddingLeft: 30,
    paddingRight: 30,
  },
  fieldArabicNote: {
    fontSize: 14,
    fontFamily: 'Amiri',
    textAlign: 'right',
    marginTop: 2,
  },
});

export default EntryAuthorizationPDF;
